import Recat from 'react'
import {Component} from 'react'
import './Home.css'

import Display from './Display'
import Copyright from './Copyright'
import socialPostIm from './socialPostIm.webp'
import productDescIm from './productDescIm.webp'
import googlesearchIm from './googlesearchIm.webp'
import coldEmailIm from './coldEmailIm.webp'



export default function Home(){
  return(
    <div>
     <h1 style={{textAlign:"center",color:"white", fontWeight:"bold", marginBottom: "2rem", marginTop:"6rem", padding: "2rem"}}>Unlock the <span style={{backgroundImage: "linear-gradient(60deg, #00eeff, #ff00d9)", webkitBackgroundClip: "text",
    webkitTextFillColor: "transparent"}}>Power of AI</span> Writing</h1>
     <div className="responsivewala" style={{display: "flex", justifyContent: "center", gap: "2rem", marginBottom: "2rem"}}>

     <Display name="Social Posts" source={socialPostIm} desc="Generate killer content for your social posts like never before & Unlock engagement!" addr="social-post-writer"/>
     <Display name="Product Description" source={productDescIm} desc="Generate beautiful and effective product descriptions that catches attention & sells!" addr="product-description-writer"/>
     <Display name="SEO Content" source={googlesearchIm} desc="Get seo content that is optimized for higher search engine rankings!" addr="seo-content-writer"/>
     <Display name="Cold Email" source={coldEmailIm} desc="Write powerful cold email optimized for conversion & scale your outreach process!" addr="cold-email"/>
     </div>

    </div>

  )
}
